import { render, staticRenderFns } from "./xmlTest.vue?vue&type=template&id=2fec79f0&scoped=true&"
import script from "./xmlTest.vue?vue&type=script&lang=js&"
export * from "./xmlTest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fec79f0",
  null
  
)

export default component.exports